import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAdmin } from '../store/slices/adminSlice';

const AdminNavbar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { authUser, vendorProfile } = useSelector((state) => state.admin);

    const handleLogout = async () => {
        await dispatch(logoutAdmin());
        navigate('/admin/login');
    };

    const isDev = process.env.NODE_ENV !== 'production';

    return (
        <header className="bg-white border-bottom sticky-top z-3 py-8 py-md-12 shadow-2xs">
            <div className="container container-lg d-flex align-items-center justify-content-between gap-8 flex-wrap">
                <div className="d-flex align-items-center gap-12 gap-md-24 flex-wrap">
                    <Link to="/" className="d-flex align-items-center gap-8 text-decoration-none">
                        <img src="/logo192.png" alt="Catálogo App" className="w-28 h-28 w-md-32 h-md-32 object-fit-contain" />
                        <span className="fw-bold text-gray-900 text-sm text-md-lg tracking-tight d-none d-sm-inline">Catálogo App</span>
                    </Link>

                    <nav className="d-flex align-items-center gap-4 gap-md-8">
                        <Link 
                            to="/admin/dashboard" 
                            className={`btn btn-sm rounded-pill px-10 px-md-16 py-6 fw-semibold text-xs transition-2 ${
                                location.pathname.startsWith('/admin/dashboard')
                                ? 'btn-main' 
                                : 'btn-outline-gray-200 text-gray-700 hover-bg-gray-100'
                            }`}
                        >
                            <i className="ph ph-squares-four text-sm me-0 me-md-4"></i>
                            <span className="d-none d-md-inline">Catálogos & Productos</span>
                            <span className="d-inline d-md-none">Catálogos</span>
                        </Link>

                        <Link 
                            to="/admin/profile" 
                            className={`btn btn-sm rounded-pill px-10 px-md-16 py-6 fw-semibold text-xs transition-2 ${
                                location.pathname === '/admin/profile' 
                                ? 'btn-main' 
                                : 'btn-outline-gray-200 text-gray-700 hover-bg-gray-100'
                            }`}
                        >
                            <i className="ph ph-user-gear text-sm me-0 me-md-4"></i>
                            <span className="d-none d-md-inline">Mi Perfil</span>
                            <span className="d-inline d-md-none">Perfil</span>
                        </Link>

                        {isDev && (
                            <Link 
                                to="/admin/orders" 
                                className={`btn btn-sm rounded-pill px-10 px-md-16 py-6 fw-semibold text-xs transition-2 ${
                                    location.pathname === '/admin/orders' 
                                    ? 'btn-main' 
                                    : 'btn-outline-gray-200 text-gray-700 hover-bg-gray-100'
                                }`}
                            >
                                <i className="ph ph-clipboard-text text-sm me-0 me-md-4"></i>
                                <span className="d-none d-md-inline">Pedidos</span>
                                <span className="badge bg-warning-100 text-warning-700 ms-4 text-3xs">DEV</span>
                            </Link>
                        )}
                    </nav>
                </div>

                <div className="d-flex align-items-center gap-8 gap-md-12 ms-auto ms-sm-0">
                    <div className="d-flex align-items-center gap-8 text-end">
                        {vendorProfile?.logoUrl ? (
                            <img 
                                src={vendorProfile.logoUrl} 
                                alt={vendorProfile.nombre || 'Vendedor'} 
                                className="w-28 h-28 w-md-32 h-md-32 rounded-circle object-fit-cover border" 
                            />
                        ) : (
                            <div className="w-28 h-28 w-md-32 h-md-32 rounded-circle bg-main-100 text-main-600 flex-center fw-bold text-xs">
                                {(vendorProfile?.nombre || authUser?.email || 'V')[0].toUpperCase()}
                            </div>
                        )}
                        <div className="d-none d-md-block text-start">
                            <span className="d-block text-xs fw-bold text-gray-900 leading-none">
                                {vendorProfile?.nombre || authUser?.displayName || 'Vendedor'}
                            </span>
                            <span className="d-block text-2xs text-gray-400">
                                {authUser?.email}
                            </span>
                        </div>
                    </div>

                    <button 
                        type="button" 
                        onClick={handleLogout}
                        className="btn btn-outline-danger btn-sm rounded-circle w-28 h-28 w-md-32 h-md-32 p-0 flex-center"
                        title="Cerrar Sesión"
                    >
                        <i className="ph ph-sign-out text-sm"></i>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default AdminNavbar;
